import {useMutation, useQueryClient} from '@tanstack/react-query'
import {addValid} from '../../../../store/message'
import {useActionDispatch} from '../../../utils'
import {UserFriendlyError} from '../../../../model/Error'
import {trustedSourceKeys} from "./trustedSource.keys";
import {putTrustedSourceConfiguration} from "../../../../data/admin/trustedSources/putTrustedSourceConfiguration";

type PutTrustedSourceConfigType = {
  configurationId: number;
  isEnabled: boolean
}
export const usePutTrustedSourceConfiguration = () => {
  const valid = useActionDispatch(addValid)
  const queryClient = useQueryClient()

  const queryReturn = useMutation({
    mutationFn: async ({configurationId, isEnabled}: PutTrustedSourceConfigType) => {
      if (!configurationId) {
        throw new UserFriendlyError('error', "Veuillez renseigner une pièce justificative à mettre à jour")
      }
      const {data, ok} = await putTrustedSourceConfiguration(configurationId, {
        isEnabled
      })

      if (!data || !ok) {
        throw new UserFriendlyError('error', "La mise à jour de la pièce justificative a échoué")
      }

      return data
    },

    onSuccess: () => {
      valid('La pièce justificative a été mise à jour')
      queryClient.refetchQueries({
        queryKey: trustedSourceKeys.all
      })
    },
  })
  return queryReturn
}

